/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

app.controller('dialog_editPairCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', 'Notification', function ($rootScope, $scope, $http, NetworkService, MainService, Notification) {

        NetworkService.getMitarbeiter(function (data) {
            $scope.allUsers = data;
        })

        $rootScope.$on("render_dialog_editPairCtrl", function () {
            $scope.user = MainService.getDialogData("dialog_editPairCtrl")
        })
        
        $scope.setPartner = function(partner)
        {
            $scope.user.partner = partner;
        }
        $scope.updatePair = function ()
        {
            NetworkService.updatePartner($scope.user)
        }
    }])
